import styled from 'styled-components';

const QuickPickWrapper = styled.div`
    width: auto;
    height: ${(props) => (!props.small ? '110px' : '96px')};
    border-radius: 10px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.3);
    margin: 0px 10px 40px;
    background: ${(props) => props.bg};
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
`;

export { QuickPickWrapper };
